
export const eventsInventory = {
    'Calabash Experience, Chef Mike Clancy' : {
        stock: 0
    },
    'Ma-Der! Ma-Der! \nLao Cuisine By Chef Mary and Phet July 5th 2024' : {
        stock: 30
    },
    // 'Ma-Der! Ma-Der! \nLao Cuisine By Chef Mary and Phet July 5th 2024 Vegetarian' : {
    //     stock: this['Ma-Der! Ma-Der! \nLao Cuisine By Chef Mary and Phet July 5th 2024'].stock
    // },
    // 'Ma-Der! Ma-Der! \nLao Cuisine By Chef Mary and Phet July 5th 2024 Gluten Free' : {
    //     stock: this['Ma-Der! Ma-Der! \nLao Cuisine By Chef Mary and Phet July 5th 2024'].stock
    // },
    // 'Ma-Der! Ma-Der! \nLao Cuisine By Chef Mary and Phet July 5th 2024 Vegetarian Gluten Free' : {
    //     stock: this['Ma-Der! Ma-Der! \nLao Cuisine By Chef Mary and Phet July 5th 2024'].stock
    // },
    'Ma-Der! Ma-Der! \nLao Cuisine By Chef Mary and Phet July 6th 2024' : {
        stock: 30
    },
    // 'Ma-Der! Ma-Der! \nLao Cuisine By Chef Mary and Phet July 6th 2024 Vegetarian' : {
    //     stock: this['Ma-Der! Ma-Der! \nLao Cuisine By Chef Mary and Phet July 6th 2024'].stock
    // },
    // 'Ma-Der! Ma-Der! \nLao Cuisine By Chef Mary and Phet July 6th 2024 Gluten Free' : {
    //     stock: this['Ma-Der! Ma-Der! \nLao Cuisine By Chef Mary and Phet July 6th 2024'].stock
    // },
    // 'Ma-Der! Ma-Der! \nLao Cuisine By Chef Mary and Phet July 6th 2024 Vegetarian Gluten Free' : {
    //     stock: this['Ma-Der! Ma-Der! \nLao Cuisine By Chef Mary and Phet July 6th 2024'].stock
    // },

    'Fleur De Mar \nby Chef Cole Conrad Cohen August 2nd 2024' : {
        stock: 30
    },
    'Fleur De Mar \nby Chef Cole Conrad Cohen August 3rd 2024' : {
        stock: 30
    },
    'Chuseok \nby Mountain Song Kitchen September 5th 2024' : {
        stock: 30
    },
    'Chuseok \nby Mountain Song Kitchen September 6th 2024' : {
        stock: 30
    },
    'A Taste of Season in Vermont \nby Chefs Samantha Langevin and Jeannie Kovacs October 5th 2024' : {
        stock: 30
    },
    
}
 